export const normalizeValue = (
  valuesForType: readonly string[],
  value?: string | null,
): string | undefined => {
  if (!value) {
    return undefined;
  }

  const lowerValue = value.toLowerCase();
  for (const validValue of valuesForType) {
    if (validValue.toLowerCase() === lowerValue) {
      return validValue;
    }
  }

  return value;
};
